import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/Table';
import { IPrompt } from 'types/income';
import { getSorting } from 'utils/general';
import { PromptsFilters } from './prompts.types';

const getFilters = (filters: Partial<PromptsFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  ...getSorting(filters.sort),
  search: filters.search || undefined,
});

interface GetPrompts {
  filters: Partial<PromptsFilters>;
}

interface CreatePrompt {
  name: string;
  prompt: string;
}

interface UpdatePrompt {
  promptId: string;
  data: Partial<CreatePrompt>;
}

interface DeletePrompt {
  promptId: string;
}

export const loaders = {
  getPrompts: ({ filters }: GetPrompts) => {
    return api<TableDataResponse<IPrompt>>({
      url: Endpoints.melpAdmin.prompts.root,
      params: getFilters(filters),
    });
  },
  createPrompt: ({ name, prompt }: CreatePrompt) => {
    return api<{ id: string }>({
      url: Endpoints.melpAdmin.prompts.root,
      data: {
        name,
        prompt,
      },
      method: 'post',
    });
  },
  updatePrompt: ({ promptId, data }: UpdatePrompt) => {
    return api({
      url: Endpoints.melpAdmin.prompts.byId.replace(':promptId', promptId),
      data: {
        ...data,
      },
      method: 'patch',
    });
  },
  deletePrompt: ({ promptId }: DeletePrompt) => {
    return api({
      url: Endpoints.melpAdmin.prompts.byId.replace(':promptId', promptId),
      method: 'delete',
    });
  },
};
